import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';
import Dashboard from './pages/Dashboard';
import AuthCallback from './pages/AuthCallback';
import SensorDetail from './pages/SensorDetail';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Login from './pages/Login';
import sensorData from './data/sensor_data.json';

const supabase = createClient('https://iudzzeqvihyxbzdvooeq.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1ZHp6ZXF2aWh5eGJ6ZHZvb2VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5Nzc4MDcsImV4cCI6MjA3MjU1MzgwN30.KcSOr8Oa0fnSaeWWBNXZy0osMOdL2od_tJ3vOV_-c44');

function App() {
  const [sensors, setSensors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);

  // Auth check on mount
  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      setUser(data.session?.user || null);
      setIsLoading(false); // Arrêter le loading après vérification auth
    };
    checkSession();

    // Listen to auth changes (login/logout)
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });

    return () => {
      authListener.subscription?.unsubscribe();
    };
  }, []);

  useEffect(() => {
    // Charger les données des capteurs seulement si l'utilisateur est connecté
    if (user) {
      setTimeout(() => {
        setSensors(sensorData.sensors);
      }, 1000);
    }
  }, [user]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-slate-600 text-lg">Chargement des capteurs...</p>
        </div>
      </div>
    );
  }

  // Si pas authentifié, afficher uniquement la page login
  if (!user) {
       return (
           <Routes>
             <Route path="/auth/callback" element={<AuthCallback />} />
             <Route path="*" element={<Login />} />
           </Routes>
         );
  }

  // Si authentifié, afficher le système
  return (
    <div className="min-h-screen flex bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        sensors={sensors}
      />
      <div className="flex-1 flex flex-col">
        <Header 
          onMenuClick={() => setSidebarOpen(true)}
          sensors={sensors}
        />
        <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8">
          <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<Dashboard sensors={sensors} />} />
            
            <Route path="/sensor/:id" element={<SensorDetail sensors={sensors} />} />
            <Route path="/analytics" element={<Analytics sensors={sensors} />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
